import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq is already loaded
    if ((window as any).fbq) return;
    // Initialize fbq function
    const n = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    } as any;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    (window as any).fbq = n;
    (window as any)._fbq = n;
    // Load the fbevents.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1668014427688483');
    (window as any).fbq('track', 'PageView');
    return () => {
      // Cleanup on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return null;
}